import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export async function postAdminResetPassword({ email, appOrigin }) {
  const { data } = await axios.post(
    `${getApiBase()}/admin/users/reset-password`,
    { email, appOrigin },
    { headers: authHeaders() }
  );
  return data;
}
